import { $api } from '@shared/api';
import { TAnswer } from '@widgets/UserPoll/model/types';

export const sendPollResult = ({ answer }: { answer: TAnswer }) => {
    // @ts-ignore
    const savePollResultUrl = routable.getRoute('savePollResult');

    const formData = new FormData();
    formData.append('answer', answer);

    return $api.post(savePollResultUrl, formData);
};
